import React, { FC } from 'react';
import { ReactComponent as ArrowLinkIcon } from '../../../../assets/images/arrows/ArrowsLink.svg';
import { useDebounce } from '../../../../hooks/useDebounce';

export enum TextButtonClassNames {
  Standard = 'standard',
  PrimaryActive = 'primary',
  Red = 'red',
  Gray = 'gray',
  Default = 'default',
  Accent = 'accent',
  Filled = 'filled',
}

interface AnimatedArrowProps {
  label: string | JSX.Element;
  handleClick: () => void;
  className: TextButtonClassNames | string;
  isArrow?: boolean;
  isDisabled?: boolean;
  beforeIcon?: React.ReactElement | null;
  afterIcon?: React.ReactElement | null;
  isBold?: boolean;
}

const defaultProps = {
  isArrow: false,
  isDisabled: false,
  beforeIcon: null,
  afterIcon: null,
  isBold: false,
};

export const TextButton: FC<AnimatedArrowProps> = ({
  label,
  handleClick,
  className,
  isArrow,
  isDisabled,
  beforeIcon,
  afterIcon,
  isBold,
}) => {
  const handleDebouncedClick = useDebounce(() => {
    handleClick();
  }, 200);

  return (
    <button
      type="button"
      tabIndex={0}
      className={`button button__text button__text__${className} ${
        isDisabled ? `button button__text button__text__${className} button__text_disabled` : ''
      } ${isBold ? `button button__text button__text__${className} button__text_bold` : ''}`}
      onClick={handleDebouncedClick}
      disabled={isDisabled}
    >
      {beforeIcon}
      <span>{label} </span>
      {isArrow && <ArrowLinkIcon className={`button__text__${className}__arrow`} />}
      {afterIcon}
    </button>
  );
};

TextButton.defaultProps = defaultProps;
